import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const APIKeyRoutes = defineRoute({
    record: {
        route: {
            path: "/api-key",
            component: () => loadView(import("./APIKeyTable.vue")),
        },
    },
    create: {
        route: {
            path: "/api-key/create",
            component: () => loadView(import("./APIKeyCreate.vue")),
        },
    },
    detail: {
        route: {
            path: "/api-key/detail/:id",
            component: () => loadView(import("./APIKeyUpdate.vue")),
        },
        build(id: string) {
            return `/api-key/detail/${id}`;
        },
    },
});
